import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext/AuthContext";
import { useAppContext } from "../Context/AppContext/AppContext";
import { useCurrentApplication } from "../Context/CurrentApplicationContext/CurrentApplicationContext";
import { openNotification } from "../Components/Notification/Index";
import { useLoader } from "../Context/LoaderContext/LoaderContext";
import JobApplicationService from "../Services/job.application.service";

export const useJobApplicationActions = () => {
  const navigate = useNavigate();

  const { isUserLoggedIn } = useAuth();
  const { organization } = useAppContext();
  const { setLoading, setLoadingMessage } = useLoader();
  const { jobPost, jobApplication, userProfile, refetch } =
    useCurrentApplication();

  const jobApplicationService = new JobApplicationService();

  const handleApply = async () => {
    if (!jobPost) {
      console.error("No job post found in context");
      return;
    }

    if (jobApplication) {
      openNotification(
        "info",
        "Application already exists",
        "You have already applied for this job.",
      );
      return;
    }

    if (!isUserLoggedIn) {
      const redirectUrl = `/${jobPost.slug}/requirements?action=apply`;
      navigate(`/sign-in?redirect_url=${encodeURIComponent(redirectUrl)}`);
      return;
    }

    setLoading(true);
    setLoadingMessage("Initiating your application...");
    await jobApplicationService.sendJobApplication(
      jobPost._id,
      [],
      organization?.orgName || "Null Organization",
      jobPost.title,
    );
    openNotification("success", "Application initiated, upload resume to continue", "");
    await refetch();
  };

  return {
    handleApply,
  };
};
